import { HTTP } from "@/utils/http-common"

export default {
  async getAll() {
    const path = `/account/companies`
    const response = await HTTP.get(path)
    return response.data.results
  },
  async getOwned() {
    const path = `/account/companies`
    const params = { perm: "owner" }
    const response = await HTTP.get(path, { params })
    return response.data.results
  },
  async getById(companyId) {
    const path = `/account/companies/${companyId}`
    const response = await HTTP.get(path)
    return response.data
  },
  getMembers(companyId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`account/company/${companyId}/team`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  sendInvite($, companyId, invites) {
    return new Promise((resolve, reject) => {
      HTTP.post(`account/company/${companyId}/team`, invites)
        .then(function (response) {
          if (!response.data.invalid || response.data.invalid.length === 0) {
            $.$store.commit("app/message", {
              msg: "invite(s) sent",
              color: "success"
            })
            $.invites = [
              {
                email: "",
                errors: "",
                privileges: {
                  inspector: false,
                  operator: true
                }
              }
            ]
          } else {
            let data = response.data
            let item, email, index
            for (item in data.invalid) {
              for (let prop in data.invalid[item]) {
                email = prop
                break
              }
              index = invites.findIndex(x => x.email == email)
              $.invites[index].errors = data.invalid[item][email]
            }
            $.$store.commit("app/message", {
              msg: "some invites failed or are already pending",
              color: "warning"
            })
          }
          return resolve(response)
        })
        .catch(function (error) {
          let data = error.response.data
          if (data !== undefined) {
            let item, email, index
            if (data.error) {
              $.$store.commit("app/message", {
                msg: data.error,
                color: "error"
              })
            } else if (data.invalid) {
              for (item in data.invalid) {
                for (let prop in data.invalid[item]) {
                  email = prop
                  break
                }
                index = invites.findIndex(x => x.email == email)
                $.invites[index].errors = data.invalid[item][email]
              }
              $.$store.commit("app/message", {
                msg: "An email has already been sent to this user",
                color: "error"
              })
            } else {
              $.$store.commit("app/message", {
                msg: data.detail,
                color: "error"
              })
            }
          } else {
            $.$store.commit("app/message", {
              msg: data,
              color: "error"
            })
          }
          return reject(error)
        })
    })
  },
  selfRemoveFromCompany($, companyId) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`account/company/${companyId}/team`).then(r => {
        resolve(r.data)
      })
    })
  },
  removeFromTeam($, userId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`account/company/team/delete`, { id: userId })
        .then(function (response) {
          $.$store.commit("app/message", {
            msg: "User removed from the team",
            color: "success"
          })
          resolve(response)
        })
        .catch(error => {
          const message = error.response.data.error
          $.$store.commit("app/message", {
            msg: message,
            color: "warning"
          })
          reject(error)
        })
    })
  },
  projects: {
    async get(companyId) {
      const path = `/projects/company/${companyId}`
      const response = await HTTP.get(path)
      return response.data
    }
  }
}
